export { default as List } from 'roles/containers/RolesListContainer';
export { default as Form } from 'roles/containers/RoleFormContainer';



// WEBPACK FOOTER //
// src/modules/secured/modules/roles/containers/index.js